export default __webpack_public_path__ + "static/media/penalty.6d17797d.svg";